var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20002 10.3902V1.61021L7.24102 6.00021L1.20002 10.3902ZM8.42002 5.37421L1.22902 0.149208C1.11382 0.0648606 0.977433 0.0142065 0.8351 0.00290463C0.692767 -0.00839722 0.550095 0.0200984 0.423023 0.0852077C0.295419 0.149623 0.188265 0.248286 0.113557 0.37015C0.0388491 0.492014 -0.000462528 0.632268 2.34607e-05 0.775208V11.2252C-0.000772442 11.3272 0.0186898 11.4283 0.0572802 11.5226C0.0958706 11.617 0.15282 11.7028 0.224825 11.775C0.296831 11.8472 0.382456 11.9044 0.476734 11.9432C0.571011 11.982 0.672063 12.0017 0.774024 12.0012C0.937554 12.0014 1.09677 11.9487 1.22802 11.8512L8.42002 6.62721C8.51862 6.55541 8.59896 6.46143 8.65454 6.35286C8.71013 6.24429 8.73941 6.12418 8.74002 6.00221C8.73972 5.87976 8.7106 5.7591 8.655 5.65C8.59941 5.5409 8.51891 5.44642 8.42002 5.37421V5.37421Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.64ea072713a113979dc5e3275b235686.svg";
export { ForwardRef as ReactComponent };